module.exports = __webpack_public_path__ + "img/LR-hauptseite_kachel-mens-shot.2170f3b0.png";